import React from 'react';
import { Target, Users, Zap } from 'lucide-react';

const goals = [
  {
    icon: Target,
    title: 'Public Sector Excellence',
    description: 'Delivering government-standard 15:1 ROI with full compliance and UK data residency'
  },
  {
    icon: Users,
    title: 'Social Value Commitment',
    description: 'Measurable contributions to economic equality, climate action, and community wellbeing'
  },
  {
    icon: Zap,
    title: 'Security First',
    description: 'Cyber Essentials Plus and ISO 27001:2022 certified with transparent ATRS compliance'
  }
];

export default function MissionSection() {
  return (
    <section className="relative py-12">
      <div className="absolute inset-0 bg-gradient-to-b from-gray-900/90 via-gray-900/85 to-gray-900/90" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="glass-card p-8 rounded-xl backdrop-blur-md">
          <div className="max-w-3xl mx-auto text-center mb-12">
            <h2 className="text-4xl font-bold mb-6">
              <span className="text-gradient">Our Mission Today</span>
            </h2>
            <div className="space-y-6 text-lg text-gray-300">
              <p className="leading-relaxed">
                Founded in 2023, TacticalSolutions.ai emerged from a clear mission: to deliver enterprise-grade AI automation to the UK public sector with uncompromising security, measurable ROI, and genuine social value impact.
              </p>
              <p className="leading-relaxed">
                As a UK-based SME supplier, we understand the unique challenges facing government departments, NHS trusts, and local councils. Our approach combines technical excellence with deep knowledge of public sector procurement, compliance requirements, and social value frameworks.
              </p>
              <p className="leading-relaxed">
                Today, we're G-Cloud 14 approved and working toward Cyber Essentials Plus and ISO 27001:2022 certification, ensuring every solution meets the highest government security standards while delivering typical 2-3 month payback periods.
              </p>
              <blockquote className="border-l-4 border-teal-500 pl-4 my-6 italic text-gray-200">
                "We're not just implementing technology; we're helping public sector organizations deliver better services to citizens while maximizing value for taxpayers."
              </blockquote>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {goals.map((goal, index) => (
              <div
                key={index}
                className="glass-card p-6 rounded-xl backdrop-blur-md transform hover:scale-105 transition-all duration-300"
              >
                <div className="flex flex-col items-center text-center">
                  <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-teal-500 to-purple-500 p-2.5 flex items-center justify-center mb-4">
                    <goal.icon className="w-full h-full text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2">{goal.title}</h3>
                  <p className="text-gray-300">{goal.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}